import axios from "../axios";

export const getAllTeachers = async() => {
   
   const {data} = await axios.get('teachers')
  
   return data
}